module.exports = __webpack_public_path__ + "img/3ed6700.jpg";